"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Asynchronously loads the component for NetIncome
 */
// import React, { lazy, Suspense, ReactNode } from 'react';
const React = __importStar(require("react"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const retryPromise_1 = __importDefault(require("utils/retryPromise"));
const Component = React.lazy(() => (0, retryPromise_1.default)(() => Promise.resolve().then(() => __importStar(require('./index')))));
const loadable = (props) => <React.Suspense fallback={<LoadingView_1.default />}>
    <Component {...props}/>
  </React.Suspense>;
exports.default = loadable;
